import React from 'react';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import { PausedSuggestedAction } from 'router/subrouters/DataRoom/models/Dashboard';
import { Button } from 'ncoded-component-library';
import { generateDaysLeftString } from 'dateUtils';
import useGetPausedSuggestedAction from '../../hooks/useGetPausedSuggestedAction';
import { ACTIVE_SUGGESTION_TITLE } from '../../data';
import SuggestedActionIcon from '../SuggestedActionIcon';
import ClockIcon from 'icons/Clock.icon';
import BellOfIcon from 'icons/BellOf.icon';
import RefreshIcon from 'icons/Refresh.icon';

import './MutedSuggestionActionItem.styles.scss';

type MutedSuggestionActionItemProps = {
  className?: string;
  pausedSuggestion: PausedSuggestedAction;
};

const MutedSuggestionActionItem: React.FC<MutedSuggestionActionItemProps> = (
  props,
) => {
  const { className, pausedSuggestion } = props;

  const { type, mutedUntil, count, expiredAt, names } = pausedSuggestion;

  const title = ACTIVE_SUGGESTION_TITLE[type];
  const secureLink = names?.[0];
  const time = generateDaysLeftString(expiredAt);

  const classes = classNames('muted-suggestion-action-item', className);

  const { t } = useTranslation();

  const { isRestoring, onRestore } =
    useGetPausedSuggestedAction(pausedSuggestion);

  return (
    <div className={classes}>
      <div className="muted-suggestion-action-item__wrapper">
        <SuggestedActionIcon type={type} />

        <div className="muted-suggestion-action-item__content">
          <p>{t(title, { count, secureLink, time })}</p>
          <p>
            {mutedUntil ? (
              <>
                <ClockIcon />
                {t('unmuteInTime', {
                  time: generateDaysLeftString(mutedUntil),
                })}
              </>
            ) : (
              <>
                <BellOfIcon />
                {t('permanentlyMuted')}
              </>
            )}
          </p>
        </div>
      </div>

      <Button icon={RefreshIcon} disabled={isRestoring} onClick={onRestore}>
        {t('restore')}
      </Button>
    </div>
  );
};

export default MutedSuggestionActionItem;
